
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/products/[product]",
      function () {
        return require("private-next-pages/learn/products/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/products/[product]"])
      });
    }
  